import { FormHelperText } from '@mui/material';
import React from 'react';
import { FieldValues, FormState } from 'react-hook-form';

export interface FormErrorProps<T extends FieldValues> {
  formState: FormState<T>;
  name: string;
}

const FormError = <T extends FieldValues>({ formState, name }: FormErrorProps<T>) =>
  formState.errors?.[name] ? (
    <FormHelperText>{(formState.errors?.[name]?.message as string) ?? undefined}</FormHelperText>
  ) : null;

export default FormError;
